import { useContext } from "react";
import { LatestOnlineVisitsContext } from "./LatestOnlineVisitsProvider";
import { OnlineVisitBase } from "src/api/types";

export function useLatestOnlineVisit<T>(
  selector: (onlineVisits: OnlineVisitBase[]) => T,
) {
  const onlineVisits = useContext(LatestOnlineVisitsContext);

  if (onlineVisits == null) {
    return null;
  }

  return selector(onlineVisits);
}
